import { jsx as _jsx } from "react/jsx-runtime";
export const ExclamationMarkTriangleS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M12.8656 2.50222L21.8559 18.1164C22.2604 18.817 21.7803 19.7501 20.9115 19.7502H3.08725C2.24912 19.7499 1.72495 18.8429 2.14291 18.1164L11.1332 2.50222C11.5312 1.8242 12.4883 1.84375 12.8656 2.50222ZM3.79624 18.2502H20.2026L11.9994 4.00417L3.79624 18.2502ZM11.9994 14.2502C12.4136 14.2502 12.7494 14.586 12.7494 15.0002V16.0002C12.7492 16.4143 12.4135 16.7502 11.9994 16.7502C11.5854 16.7501 11.2495 16.4142 11.2494 16.0002V15.0002C11.2494 14.5861 11.5853 14.2503 11.9994 14.2502ZM11.9994 7.75025C12.4136 7.75025 12.7494 8.08603 12.7494 8.50025V12.0002C12.7492 12.4143 12.4135 12.7502 11.9994 12.7502C11.5752 12.7501 11.2494 12.4102 11.2494 12.0002V8.50025C11.2494 8.08611 11.5853 7.75037 11.9994 7.75025Z",
            fill: color
        })
    });

//# sourceMappingURL=exclamation-mark-triangle-s.js.map